// extracted by mini-css-extract-plugin
export default {"offerItem":"OfferItems_offerItem__IXDPT","offerItem1":"OfferItems_offerItem1__WJQA6","offerItem2":"OfferItems_offerItem2__6H5GL"};